import BlogPlugin from './blog-plugin/blog-plugin';
import ErrorHandlerPlugin from './error-handler-plugin/error-handler-plugin';
import ExitModalHandlerPlugin from './exit-modal-handler/exit-modal-handler';
import ModalHandlerPlugin from './modal-handler/modal-handler';
import PolyfillsPlugin from './polyfills-plugin/polyfills-plugin';
import ProfilePopupContainerPlugin from './profile-popup-container/profile-popup-container';
import ScrollHandlerPlugin from './scroll-handler/scroll-handler';
import SignupModal from './signup-modal/signup-modal';
import TrackingHandlerPlugin from './tracking-handler/tracking-handler';

export default [
  BlogPlugin,
  ErrorHandlerPlugin,
  ExitModalHandlerPlugin,
  ModalHandlerPlugin,
  PolyfillsPlugin,
  ProfilePopupContainerPlugin,
  SignupModal,
  ScrollHandlerPlugin,
  TrackingHandlerPlugin,
];
